var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "mt-3 table-stats",
        attrs: {
          items: _vm.workerStatsTable,
          fields: this.getFields,
          busy: _vm.loading,
          "show-empty": "",
          "empty-text": "Смен работника за выбранный период не найдено",
          striped: "",
          "foot-clone": ""
        },
        scopedSlots: _vm._u([
          {
            key: "[date]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$moment(data.value).format("DD.MM.YYYY")) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "[timeOpened]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$moment(data.value).format("HH:mm DD.MM.YYYY")) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "[timeClosed]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      data.value
                        ? _vm.$moment(data.value).format("HH:mm DD.MM.YYYY")
                        : "-"
                    ) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "[restPoint]",
            fn: function(data) {
              return [_vm._v("\n    " + _vm._s(data.value) + "\n  ")]
            }
          },
          {
            key: "[hour]",
            fn: function(data) {
              return [_vm._v("\n    " + _vm._s(data.value) + "\n  ")]
            }
          },
          {
            key: "[hoursOnWork]",
            fn: function(data) {
              return [
                _vm._v("\n    " + _vm._s(_vm.formatHours(data.value)) + "\n  ")
              ]
            }
          },
          {
            key: "[totalWorkersHoursByPointDay]",
            fn: function(data) {
              return [_vm._v("\n    " + _vm._s(data.value) + "\n  ")]
            }
          },
          {
            key: "[]",
            fn: function(data) {
              return [_vm._v("\n    " + _vm._s(data.value.toFixed(2)) + "\n  ")]
            }
          },
          {
            key: "FOOT[date]",
            fn: function(data) {
              return [_vm._v("\n    Итого:\n  ")]
            }
          },
          {
            key: "FOOT[hoursOnWork]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm.formatHours(_vm.workerStatsSummary.hoursOnWork)
                    ) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "FOOT[sumFromHours]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.workerStatsSummary.sumFromHours.toFixed(2)) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "FOOT[sumPercentageOfTurnover]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm.workerStatsSummary.sumPercentageOfTurnover.toFixed(2)
                    ) +
                    "\n  "
                )
              ]
            }
          },
          {
            key: "FOOT[total]",
            fn: function(data) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.workerStatsSummary.total.toFixed(2)) +
                    "\n  "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e999189", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e999189","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MotivateCookerTableStats.vue
// module id = null
// module chunks = 